import { colors } from '@lmc/common/constants'
import { ITEM_ID_SEIZURE, ITEM_ID_SHORT_SEIZURE } from '@lmc/common/types'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { ChartLogList } from '../../../../components/generic'
import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import Highcharts from './Highcharts'

class SeizureChart extends Component {
  formatSeriesData(data) {
    // transform the logs into a format expected by highcharts
    return _.chain(data)
      .filter((d) => !d.deleted)
      .groupBy((log) =>
        dayjs(log.timeLogged).startOf('day').add(1, 'h').format()
      )
      .map((value, date) => {
        return [Date.parse(dayjs(date).toString()), value?.length] // { x: date, y: total };
      })
      .value()
  }

  render() {
    const { logs } = this.props

    const logsSeizureType = logs?.filter(
      (log) => log.itemId === ITEM_ID_SEIZURE
    )

    const logsShortSeizureType = logs?.filter(
      (log) => log.itemId === ITEM_ID_SHORT_SEIZURE
    )

    const series = [
      // eslint-disable-next-line valid-typeof
      ...(Array.isArray(logsSeizureType) && !!logsSeizureType?.length
        ? [
            {
              color: colors.red,
              logs: logsSeizureType
            }
          ]
        : []),
      // eslint-disable-next-line valid-typeof
      ...(Array.isArray(logsShortSeizureType) && !!logsShortSeizureType?.length
        ? [
            {
              color: colors.purple,
              logs: logsShortSeizureType
            }
          ]
        : [])
    ].map(({ logs, ...row }) => ({
      ...row,
      name: logs?.[0]?.item,
      data: this.formatSeriesData(logs)
    }))

    const config = {
      title: chartTitles.seizure,
      yAxisLabel: 'Frequency (no. per day)',
      yMax: 10,
      legendEnabled: true,
      chartType: 'column',
      series,
      plotOptions: {
        turboThreshold: 10000
      }
    }

    return logs && logs.length ? (
      <div>
        <Highcharts config={config} />
        <ChartLogList logs={logs} />
      </div>
    ) : (
      <EmptyState
        title="Shoot... No data to show you"
        description="No logs to display"
        icon={<NoDataIcon />}
      />
    )
  }
}

SeizureChart.propTypes = {
  logs: PropTypes.array
}

export default withToolbar(SeizureChart, {
  pdfExport: {
    title: 'Seizure Chart'
  },
  timeWindow: 7 * 4
})
